import { createAction } from '@ngrx/store';
const ActionPrefix = 'Shared';

export const Noop = createAction(`[${ActionPrefix}] Nothing To Do`);

export const InitStart = createAction(`[${ActionPrefix}] Init Start`);
export const InitEnd = createAction(`[${ActionPrefix}] Init End`);

export const Login = createAction(`[${ActionPrefix}] Login`);
export const Logout = createAction(`[${ActionPrefix}] Logout`);
